import React from "react"
import { FilterState, FilterOption } from "QuorumGrassroots/widgets/ReusableComponents/FilterButton/FilterButton.helper"
import {
    StyledFilterContent,
    StyledFilterSection,
    StyledCheckbox,
    FilterTitle,
} from "QuorumGrassroots/widgets/ReusableComponents/FilterButton/FilterButton.styles"

export interface FilterContentProps {
    filters: FilterState
    showTypeFilter: boolean
    typeOptions: FilterOption[]
    partyOptions: FilterOption[]
    onFiltersChange: (filters: FilterState) => void
}

export const FilterContent: React.FC<FilterContentProps> = ({
    filters,
    showTypeFilter,
    typeOptions,
    partyOptions,
    onFiltersChange,
}) => {
    const handleFilterChange = (groupId: "type" | "party", optionId: string, checked: boolean) => {
        onFiltersChange({
            ...filters,
            [groupId]: {
                ...filters[groupId],
                [optionId]: checked,
            },
        })
    }

    return (
        <StyledFilterContent>
            <FilterTitle id="filter-menu-title">Filters</FilterTitle>

            {showTypeFilter && (
                <StyledFilterSection role="group" aria-labelledby="type-filter-heading">
                    <h4 id="type-filter-heading">Type</h4>
                    {typeOptions.map((option) => (
                        <StyledCheckbox
                            key={option.id}
                            label={option.label}
                            checked={filters.type[option.id] || false}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                handleFilterChange("type", option.id, event.currentTarget.checked)
                            }
                            aria-label={option.ariaLabel || `Filter by ${option.label}`}
                        />
                    ))}
                </StyledFilterSection>
            )}

            <StyledFilterSection role="group" aria-labelledby="party-filter-heading">
                <h4 id="party-filter-heading">Party</h4>
                {partyOptions.map((option) => (
                    <StyledCheckbox
                        key={option.id}
                        label={option.label}
                        checked={filters.party[option.id] || false}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            handleFilterChange("party", option.id, event.currentTarget.checked)
                        }
                        aria-label={option.ariaLabel || `Filter by ${option.label}`}
                    />
                ))}
            </StyledFilterSection>
        </StyledFilterContent>
    )
}
